const state = {
  serviceAnnotationsModified: null
}

export default state